/**
 * CopilotKit Provider
 *
 * Wraps the application with CopilotKit for AI assistance.
 * Uses a runtime adapter for server-side AI processing.
 */

import { CopilotKit } from '@copilotkit/react-core'
import type { ReactNode } from 'react'
import { isNativeApp } from '@/lib/platform'

interface CopilotProviderProps {
  children: ReactNode
}

export function CopilotProvider({ children }: CopilotProviderProps) {
  // Always wrap with CopilotKit so domain hooks (useCopilotAction, useCopilotReadable, etc.)
  // don't throw "Remember to wrap your app in a <CopilotKit>" errors.
  // The runtime is only called when the user actually interacts with the AI assistant.
  const runtimeUrl = import.meta.env.VITE_COPILOT_RUNTIME_URL || '/api/copilot'
  const showDevConsole = !isNativeApp() && import.meta.env.DEV

  return (
    <CopilotKit runtimeUrl={runtimeUrl} showDevConsole={showDevConsole}>
      {children}
    </CopilotKit>
  )
}
